var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"example"},[_c('div',{staticClass:"example-title"},[_vm._v("Example "+_vm._s(_vm.configuration.component_type_index))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }